export default __webpack_public_path__ + "Lisa Murray.28d99fa920a1f69e7b7f.png";